import script from "./DataRuiHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataRuiHeader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__